import { render } from "./DeleteScenarioPage.vue?vue&type=template&id=086b7b3b"
import script from "./DeleteScenarioPage.vue?vue&type=script&lang=js"
export * from "./DeleteScenarioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__